<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre3">Lost Farm Camp</h1>
<div>
<img alt=" " class="calibre5" src="Images/img0004.jpg"/>
</div>
<div class="caption">
<span class="italics">SWICKEY SHOOTS THE BEAR<br class="calibre12"/></span></div>
<div class="align-center1">
</div>
<div class="calibre7" id="lost-farm-camp"><div class="level" id="chapter-iswickey-shoots-a-bear">
<span id="swickey-shoots-a-bear"></span><h2 class="level1" id="pgepubid00000"><span class="calibre13">CHAPTER I<br class="calibre12"/>SWICKEY SHOOTS A BEAR</span></h2>
<p class="align-center2"><span>Old man Avery hurried from the woods
toward his camp, evidently excited. His
daughter Swickey stood watching the
black kitten Beelzebub play a clever but rather
one-sided game with a half-dead field-mouse. As
Avery saw the girl, he raised both hands above
his head in a comical gesture of imprecation.</span></p>
<p class="calibre14"><span>“Swickey, thet bug-eatin’ ole pork-thief’s been
at the butter ag’in!”</span></p>
<p class="calibre14"><span>“Why, Pop, thet’s the second time he’s done
it!”</span></p>
<p class="calibre14"><span>“Yes, an’ he scraped all the butter he could
outen it, an’ upset the crock likewise. Swickey,
we’ve got to git that b’ar or take the butter outen
the spring-hole.”</span></p>
<p class="calibre14"><span>The girl’s brown eyes dilated. “Why don’t
you trap ’im, Pop?”</span></p>
<p class="calibre14"><span>“Law ag’in’ trappin’ b’ars in August.”</span></p>
<p class="calibre14"><span>“Law ag’in’ shootin’ deer in August, too, ain’t
they?”</span></p>
<p class="calibre14"><span>“Thet’s diff’runt. We’ve got to have fresh
meat.”</span></p>
<p class="calibre14"><span>“Ain’t b’ar meat?” she asked ironically.</span></p>
<p class="calibre14"><span>“Reckon ’tis.”</span></p>
<p class="calibre14"><span>“Then, why ain’t you a-shootin’ of him?”</span></p>
<p class="calibre14"><span>The old lumberman rubbed his hand across his
eyes, or rather his eye, for the other was nothing
more than a puckered scar, and his broad shoulders
drooped sheepishly. Then he laughed, flinging
his hand out as though it contained an unpleasant
thought which he tossed away.</span></p>
<p class="calibre14"><span>“Gol-bling it, Swickey, seems to me as lately
every time I drawed a bead on a deer, they was
three front sights on the gun, and as many as
three deer where they oughter been one. ’Sides,”
he continued, “I ain’t ketched sight of him so
fur. Now, mebby if you seen him you could
shoot—”</span></p>
<p class="calibre14"><span>Swickey grabbed the astonished Beelzebub to
her breast and did a wild and exceedingly primitive
dance before the cabin door.</span></p>
<p class="calibre14"><span>“Be-el-zebub!” she cried, “Be-el-zebub! he’s
a-goin’ to leave me shoot a b’ar—me! I ain’t
shot nothin’ but deer so fur and he’s shot more ’n
a million b’ars, ain’t you, Pop?”</span></p>
<p class="calibre14"><span>“Wa-al, mebby a hun’red.”</span></p>
<p class="calibre14"><span>“Is thet more ’n a million, Pop?”</span></p>
<p class="calibre14"><span>The smile faded from Avery’s face. Huge,
gray-bearded, pensive, he stood for a moment,
as inscrutable as the front of a midnight forest.</span></p>
<p class="calibre14"><span>Swickey eyed him with awe, but Swickey at
fourteen could not be suppressed long.</span></p>
<p class="calibre14"><span>“Pop, one of your buttins is busted.”</span></p>
<p class="calibre14"><span>Her father slid his hand down his suspender
strap and wrinkled the loose leather end round his
thumb.</span></p>
<p class="calibre14"><span>“How many’s a hun’red, Pop?”</span></p>
<p class="calibre14"><span>Avery spoke more slowly than usual. “You
git the cigar-box where be my ca’tridges.”</span></p>
<p class="calibre14"><span>“Be I goin’ to shoot now?” she exclaimed, as
she dropped the kitten and skipped into the
cabin.</span></p>
<p class="calibre14"><span>“Got to see him fust,” he said, as she returned
with the cigar-box and his glasses.</span></p>
<p class="calibre14"><span>“Here they be, Pop, and here’s your ‘specs.’”
Avery adjusted his spectacles, carried the box of
cartridges to the chopping-log and sat down.
Beelzebub, who had recovered his now defunct
field-mouse, tried to make himself believe it was
still alive by tossing it up vigorously and catching
it with a curved and graceful paw.</span></p>
<p class="calibre14"><span>“You count ’em, Swickey, as I hand ’em to
you.”</span></p>
<p class="calibre14"><span>“One.”</span></p>
<p class="calibre14"><span>“One,” she replied hurriedly.</span></p>
<p class="calibre14"><span>“Two.”</span></p>
<p class="calibre14"><span>“Two,” she repeated briskly.</span></p>
<p class="calibre14"><span>“Three.”</span></p>
<p class="calibre14"><span>“Thr-ee.” She turned the shells over in her
hand slowly.</span></p>
<p class="calibre14"><span>“Four.”</span></p>
<p class="calibre14"><span>“Four’s ’nough to shoot a b’ar, ain’t it, Pop?”</span></p>
<p class="calibre14"><span>“Five,” continued Avery, disregarding her
question.</span></p>
<p class="calibre14"><span>Swickey counted on her fingers. “One he guv
me; two he guv me; then he guv me ’nother.
Them’s two and them’s two and thet’s four, and
this one makes five—is thet the name fur it?”</span></p>
<p class="calibre14"><span>“Yes, five,” he replied.</span></p>
<p class="calibre14"><span>“Yes, five,” replied Swickey. “Ain’t five
’nough?”</span></p>
<p class="calibre14"><span>The old man paused in his task and ran his
blunt fingers through the mass of glittering shells
that sparkled in the box. The glint of the cartridges
dazzled him for a moment. He closed his
eyes and saw a great gray horse standing in the
snow beneath the pines, blood trickling from a
wounded forward shoulder, and then a huddled
shape lying beneath the horse. Presently Nanette,
Swickey’s mother, seemed to be speaking to
him from that Somewhere away off over the tree-tops.
“Take care of her, Bud,” the voice seemed
to say, as it trailed off in the hum of a noonday
locust overhead. The counting of the shells continued.
Painfully they mounted to the grand total
of ten, when Swickey jumped to her feet, scattering
the cartridges in the grass.</span></p>
<p class="calibre14"><span>“I don’t want to shoot no million b’ars or no
hun’red to oncet.”</span></p>
<p class="calibre14"><span>There were tears of anger and chagrin in her
voice. She had tried to learn. The lessons usually
ended that way. Rebellion on Swickey’s part
and gentle reproof from her father.</span></p>
<p class="calibre14"><span>“Don’t git mad, Swickey. I didn’t calc’late to
hurt you,” said the old man, as he stooped and
picked up the cartridges.</span></p>
<p class="calibre14"><span>He had often tried to teach her what he knew
of “book larnin’,” but his efforts were piteously
unsuccessful. She was bright enough, but the
traps, the river, her garden-patch, the kitten, and
everything connected with their lonely life at
Lost Farm had an interest far above such vague
and troublesome things as reading and writing.</span></p>
<p class="calibre14"><span>Once, after a perspiring half-hour of endeavor
on her father’s part and a disinterested fidgeting
on hers, she had said, “Say, Pop, I ain’t never
goin’ away from you, be I?”</span></p>
<p class="calibre14"><span>To which he had replied, “No, Swickey, not
if you want to stay.”</span></p>
<p class="calibre14"><span>“Then, ding it, Pop, ain’t I good ’nough fur
you jest as I be, ’thout larnin’?”</span></p>
<p class="calibre14"><span>This was an argument he found difficult to
answer. Still, he felt he was not doing as her
mother would have wished, for she often seemed
to speak to him in the soft </span><em class="italics">patois</em><span> of the French-Canadian,
when he was alone, by the river or on
the hills.</span></p>
<p class="calibre14"><span>As he sat gazing across the clearing he thought
he saw something move in the distance. He
scowled quizzically over his spectacles. Then he
drew his daughter to him and whispered, “See
thar, gal! You git the rifle.”</span></p>
<p class="calibre14"><span>She glided to the cabin noiselessly and returned
lugging the old .45 Winchester. Avery pointed
toward a lumbering black patch near the river.</span></p>
<p class="calibre14"><span>“He’s too fur,” she whispered.</span></p>
<p class="calibre14"><span>“You snick down through the bresh back of
the camp. Don’t you shoot less’n you kin see his
ear plain.”</span></p>
<p class="calibre14"><span>The girl stooped and glided behind the cabin,
to reappear for a moment at the edge of the wood
bordering the clearing. Then her figure melted
into the shadows of the low fir trees. Avery
sat tensely watching the river-edge.</span></p>
<p class="calibre14"><span>Swickey had often rested the heavy barrel of
the old rifle on a stump or low branch, and blazed
away at some unsuspecting deer feeding near
the spring in the early morning or at dusk, with
her father crouching behind her; but now she
was practically alone, and although she knew that
bruin would vanish at the first suspicion of her
presence, she trembled at the thought that he
might seek cover in the very clump of undergrowth
in which she was concealed. She peered
between the leafy branches. There he was, sitting
up and scraping the over-ripe berries from the
bushes clumsily. She raised the rifle and then
lowered it. It was too heavy to hold steadily, and
there was no available branch or log upon which
to rest it. A few yards ahead of her was a moss-topped
pine stump. Shoving the rifle along the
ground she wriggled toward the stump and
sighed her relief when she peeped over its bleached
roots and saw the bear again. He was sitting up
as before, but his head was moving slowly from
side to side and his little eyes were shifting uneasily.
She squirmed down behind the rifle, hugging
it close as her father had taught her. The
front sight glistened an inch below the short black
ear. She drew a long breath and wrapping two
fingers round the trigger, pulled steadily.</span></p>
<p class="calibre14"><span>With the </span><em class="italics">r-r-r-ri-p-p, boom</em><span>! of the Winchester,
and as the echoes chattered and grumbled away
among the hills, the bear lunged forward with a
prolonged </span><em class="italics">whoo-owoow</em><span>, got up, stumbled over a
log, and turning a disjointed somersault, lay still.</span></p>
<p class="calibre14"><span>The old man ran toward the spot. “Don’t tetch
him!” he screamed.</span></p>
<p class="calibre14"><span>From the fringe of brush behind the bear came
Swickey, rifle in hand. Disregarding her father
she deliberately poked bruin in the ribs with the
gun-muzzle. His head rolled loosely to one side.
She gave a shrill yell of triumph that rang through
the quiet afternoon, startling the drowsy birds to
a sudden riotous clamoring.</span></p>
<p class="calibre14"><span>Avery, panting and sweating, ran to his daughter
and clasped her in his arms. “Good fur you!
You’re my gal! Hit him plump in the ear.” And
he turned the carcass over, inspecting it with a
critical eye.</span></p>
<p class="calibre14"><span>“Goin’ on five year, I reckon. A he one, too.
Fur’s no good; howcome it were a bing good
shot for a gal.”</span></p>
<p class="calibre14"><span>“Don’t care if the fur ain’t no good, he’s bigger
nor you and me put t’gither, ain’t he, Pop?”</span></p>
<p class="calibre14"><span>“Wal, not more ’n four times,” said Avery, as
he reached for the short, thin-bladed skinning-knife
in his belt and began to deftly work the
hide off the animal. Swickey, used to helping him
at all times, held a corner of the hide here and a
paw there, while the keen blade slipped through
the fat already forming under the bear’s glossy
black coat. Silently the old man worked at cutting
up the carcass.</span></p>
<p class="calibre14"><span>“Godfrey!” The knife had slipped and bit
deep into his hand.
“Why, Pop! Looks as if you done it a-pu’pose.
I was watchin’ you.”</span></p>
<p class="calibre14"><span>“It’s the specs. They don’t work right somehow.”</span></p>
<p class="calibre14"><span>The girl ran to the cabin and returned with a
strip of cloth with which she bound up the cut.</span></p>
<p class="calibre14"><span>“Thar, pop. It ain’t hurtin’ you, be it?”</span></p>
<p class="calibre14"><span>“N-o-o.”</span></p>
<p class="calibre14"><span>“We kin bile some ile outen him,” said Swickey,
as with a practical eye she estimated the results.</span></p>
<p class="calibre14"><span>“Three gallon, mebby?”</span></p>
<p class="calibre14"><span>“How much does thet make in money?”</span></p>
<p class="calibre14"><span>“’Bout a dollar and a half.”</span></p>
<p class="calibre14"><span>“Say, Pop!” She hesitated.</span></p>
<p class="calibre14"><span>“Wa-al?”</span></p>
<p class="calibre14"><span>“Kin I have the money for the ile?”</span></p>
<p class="calibre14"><span>Her father paused, wiped his forehead with a
greasy hand, and nodded toward the pocket containing
his pipe and tobacco. She filled the pipe
and lighted it for him.</span></p>
<p class="calibre14"><span>“Say, Pop, I hear somebody singin’.”</span></p>
<p class="calibre14"><span>“Wha—Jumpin’ Gooseflesh! If I ain’t clean
forgot they was fifteen of them lumber-jacks
comin’ fur supper. Ya-as, thar they be down along
shore. Swickey, you skin fur the house and dig
into the flour bar’l—quick! We’ll be wantin’
three bake-sheets. I’ll bring some of the meat.”</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?296a7a58